module.exports = "/static/js/6e81824d1083de1c986097efa81cf7d5.png";